/* Draft Cart Drawer
   Two responsibilities:
   1. Slide-out drawer that intercepts ATC submits + cart-icon clicks
   2. Wires up the existing cart-page trash button + qty buttons (so they actually work)
*/
(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────────
     PART 1: DRAWER
     ────────────────────────────────────────────────────────────── */

  var drawer = document.getElementById('draftDrawer');
  if (drawer) {
    var itemsEl  = drawer.querySelector('[data-drawer-items]');
    var emptyEl  = drawer.querySelector('[data-drawer-empty]');
    var footEl   = drawer.querySelector('[data-drawer-foot]');
    var totalEl  = drawer.querySelector('[data-drawer-total]');
    var savEl    = drawer.querySelector('[data-drawer-savings]');
    var savValEl = drawer.querySelector('[data-drawer-savings-val]');
    var subEl    = drawer.querySelector('[data-drawer-sub]');

    function money(cents) {
      if (typeof cents !== 'number') return '';
      return '$' + (cents / 100).toFixed(2);
    }

    function lockScroll(lock) {
      document.body.setAttribute('data-drawer-locked', lock ? 'true' : 'false');
    }

    function openDrawer() {
      drawer.setAttribute('data-open', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);
    }
    function closeDrawer() {
      drawer.setAttribute('data-open', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function setLoading() {
      itemsEl.innerHTML = '<li class="draft-drawer__loading">Updating…</li>';
      emptyEl.hidden = true;
      footEl.hidden = true;
    }

    function updateHeaderCount(count) {
      var nodes = document.querySelectorAll('[data-cart-count], .cart-count, .header-cart-count, [data-header-cart-count]');
      nodes.forEach(function (n) {
        n.textContent = String(count);
        if (count > 0) { n.removeAttribute('hidden'); n.style.display = ''; }
      });
    }

    function lineHtml(item) {
      var img = item.image
        ? '<img class="draft-drawer__item-img" src="' + item.image + '" alt="' + escapeHtml(item.product_title || '') + '" loading="lazy">'
        : '<div class="draft-drawer__item-img"></div>';

      var variantLine = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantLine = '<p class="draft-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>';
      } else if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        variantLine = '<p class="draft-drawer__item-variant">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</p>';
      }

      /* Strike-through anchor: prefer the variant's compare-at (from the
         server-rendered map — /cart.js doesn't expose it), fall back to
         original_line_price (covers selling-plan discounts). */
      var compareUnit = (window.draftCompareAt && window.draftCompareAt[String(item.variant_id)]) || 0;
      var lineCompare = compareUnit * item.quantity;
      if ((item.original_line_price || 0) > lineCompare) lineCompare = item.original_line_price;
      var priceLine = money(item.final_line_price);
      if (lineCompare > item.final_line_price) {
        priceLine = '<span class="draft-drawer__item-compare">' + money(lineCompare) + '</span>' + money(item.final_line_price);
      }

      return ''
        + '<li class="draft-drawer__item" data-key="' + item.key + '">'
        +   img
        +   '<div class="draft-drawer__item-info">'
        +     '<p class="draft-drawer__item-title">' + escapeHtml(item.product_title) + '</p>'
        +     variantLine
        +     '<div class="draft-drawer__item-qty">'
        +       '<button type="button" class="draft-drawer__qty-btn" data-qty-dec aria-label="Decrease quantity">−</button>'
        +       '<span class="draft-drawer__qty-val">' + item.quantity + '</span>'
        +       '<button type="button" class="draft-drawer__qty-btn" data-qty-inc aria-label="Increase quantity">+</button>'
        +     '</div>'
        +   '</div>'
        +   '<div class="draft-drawer__item-right">'
        +     '<p class="draft-drawer__item-price">' + priceLine + '</p>'
        +     '<button type="button" class="draft-drawer__item-remove" data-remove>Remove</button>'
        +   '</div>'
        + '</li>';
    }

    function render(cart) {
      if (!cart || cart.item_count === 0) {
        itemsEl.innerHTML = '';
        emptyEl.hidden = false;
        footEl.hidden = true;
        if (subEl) subEl.style.display = 'none';
        updateHeaderCount(0);
        return;
      }
      emptyEl.hidden = true;
      if (subEl) subEl.style.display = '';
      itemsEl.innerHTML = cart.items.map(lineHtml).join('');

      totalEl.textContent = money(cart.total_price);

      /* Savings = MAX of (compare-at × qty, original_price × qty, original_line_price) − cart.total_price.
         compare-at comes from the server-rendered window.draftCompareAt map,
         since /cart.js never includes compare_at_price on line items. */
      var baseline = 0;
      cart.items.forEach(function (item) {
        var compareUnit  = (window.draftCompareAt && window.draftCompareAt[String(item.variant_id)]) || 0;
        var originalUnit = item.original_price || item.price || 0;
        var unit = compareUnit > originalUnit ? compareUnit : originalUnit;
        var lineBaseline = unit * item.quantity;
        var origLine = item.original_line_price || 0;
        if (origLine > lineBaseline) lineBaseline = origLine;
        baseline += lineBaseline;
      });
      var savings = baseline - cart.total_price;
      if (savings > 0) {
        savEl.hidden = false;
        savValEl.textContent = money(savings);
      } else {
        savEl.hidden = true;
      }

      footEl.hidden = false;
      updateHeaderCount(cart.item_count);
    }

    function fetchCart() {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); });
    }

    function refresh() {
      setLoading();
      return fetchCart().then(render).catch(function () {
        itemsEl.innerHTML = '<li class="draft-drawer__loading">Could not load cart.</li>';
      });
    }

    function changeLine(key, qty) {
      setLoading();
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(refresh);
    }

    /* Close handlers */
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') closeDrawer();
    });

    /* Qty / remove inside drawer */
    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('.draft-drawer__item');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var qtyEl = row.querySelector('.draft-drawer__qty-val');
      var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
      if (e.target.closest('[data-qty-inc]')) {
        changeLine(key, current + 1);
      } else if (e.target.closest('[data-qty-dec]')) {
        changeLine(key, Math.max(0, current - 1));
      } else if (e.target.closest('[data-remove]')) {
        changeLine(key, 0);
      }
    });

    /* Intercept cart icon clicks (any link to /cart) */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="/cart"], a[href$="/cart"], a[href*="/cart?"]');
      if (!link) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      openDrawer();
      refresh();
    });

    /* Intercept ATC form submits — guard against Shop Pay express buttons */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = (form.getAttribute('action') || '').toLowerCase();
      if (action.indexOf('/cart/add') === -1) return;

      var submitter = e.submitter;
      if (submitter) {
        var name = (submitter.getAttribute('name') || '').toLowerCase();
        var cls  = (submitter.className || '').toLowerCase();
        var isExpress = name === 'checkout'
          || cls.indexOf('shopify-payment-button') !== -1
          || submitter.closest('.shopify-payment-button')
          || submitter.closest('shop-pay-button')
          || submitter.tagName === 'SHOP-PAY-BUTTON';
        if (isExpress) return;
      }

      e.preventDefault();
      var formData = new FormData(form);
      openDrawer();
      setLoading();

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { if (!r.ok) throw new Error('Add failed'); return r.json(); })
        .then(function () { return fetchCart(); })
        .then(render)
        .catch(function () { window.location.href = '/cart'; });
    }, true);

    /* Initial header count sync */
    fetchCart().then(function (c) { updateHeaderCount(c.item_count); }).catch(function () {});
  }


  /* ──────────────────────────────────────────────────────────────
     PART 2: CART PAGE — wire the existing trash + qty buttons
     ────────────────────────────────────────────────────────────── */

  /* The cart page has buttons with data-line attributes but no JS attached.
     Hook them up: trash → POST quantity 0, qty +/- → POST new quantity.
     After any change, reload the page so totals re-render correctly. */

  function postLineChange(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  document.addEventListener('click', function (e) {
    /* Trash / remove button on cart page */
    var removeBtn = e.target.closest('.primed-cart__remove');
    if (removeBtn) {
      e.preventDefault();
      var key = removeBtn.getAttribute('data-line');
      if (!key) return;
      removeBtn.disabled = true;
      removeBtn.style.opacity = '0.5';
      postLineChange(key, 0).then(function () {
        window.location.reload();
      }).catch(function () {
        removeBtn.disabled = false;
        removeBtn.style.opacity = '';
      });
      return;
    }

    /* Qty +/- buttons on cart page */
    var qtyBtn = e.target.closest('.primed-cart__qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      var qtyWrap = qtyBtn.closest('.primed-cart__qty');
      if (!qtyWrap) return;
      var key2 = qtyWrap.getAttribute('data-line');
      var input = qtyWrap.querySelector('.primed-cart__qty-input');
      var current = parseInt(input ? input.value : '1', 10) || 1;
      var isMinus = qtyBtn.getAttribute('name') === 'minus';
      var newQty = isMinus ? Math.max(0, current - 1) : current + 1;
      qtyBtn.disabled = true;
      postLineChange(key2, newQty).then(function () {
        window.location.reload();
      }).catch(function () {
        qtyBtn.disabled = false;
      });
    }
  });
})();
